export default "__VITE_ASSET__DCDaC5Ab__"